import common from '../common';

export default {
  jpath: ['spectra', 'thermogravimetricAnalysis'],
  find: common.basenameFind,
  getProperty: common.getTargetProperty,
};
